import React, {useContext, useEffect, useState} from 'react';
import UserLocation from '../UserLocation';
import {
  Breakpoints,
  styled,
  Text
} from '@volkswagen-onehub/components-core';
import {getTranslations} from '../translations';
import {Locate} from '@volkswagen-onehub/icons-core';
import {UserLocationContext} from '../UserLocation/UserLocationContext';
import { VehicleDetailsContext } from '../utils/details-context';

const ProximityContainer = styled.div`
  display: grid;
  grid-template-columns: 24px auto;
  margin-top: ${(props) => props.theme.size.dynamic0040};

  @media screen and (min-width: ${Breakpoints.b560}px) {
    display: flex;
    align-items: center;
  }
`;

const LocateContainer = styled.div`
  grid-row: 1 / 2;
  grid-column: 1 /2;
`;

const CopyContainer = styled.div`
  grid-row: 1 / 2;
  grid-column: 2 / 3;
`;

const UserLocationContainer = styled.div`
  grid-row: 2 / 3;
  grid-column: 2 / 3;
  margin-left: 4px;

  @media screen and (min-width: ${Breakpoints.b560}px) {
    margin-left: 0;
  }
`;

const Proximity = () => {
  const trans = getTranslations();
  const context = useContext(VehicleDetailsContext);
  const vehicle = context.vehicle;
  const {province} = useContext(UserLocationContext);
  const [copy, setCopy] = useState<string | null>(null);
  const [sameProvince, setSameProvince] = useState<boolean>(false);

  useEffect(() => {
    if (!vehicle || !province) return;

    const vehicleProvince = vehicle.dealer_info.province;

    if (vehicleProvince == province) {
      setSameProvince(true);
      setCopy(trans.details.proximity.postal);
    } else {
      setSameProvince(false);
      setCopy(trans.details.proximity.province + vehicleProvince);
    }
  }, [vehicle, province]);

  return (
    <ProximityContainer>
      <LocateContainer>
        <Locate ariaLabel={trans.labels.find_location} />
      </LocateContainer>

      <CopyContainer>
        <Text>{copy}</Text>
      </CopyContainer>

      { sameProvince &&
          <UserLocationContainer>
            <UserLocation hideIcon={true} emphasis="tertiary" />
          </UserLocationContainer> }
    </ProximityContainer>
  );
};

export default Proximity;
